import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="London">
                <h1>Game Development Company in UK</h1>
              </div>
              <p className="main_para">
                TekRevol is your ultimate destination among a myriad of game
                development companies in UK that can build tailor-made gaming
                experiences, prioritizing user engagement and smooth gameplay
                across cutting-edge devices. We stand at the forefront of
                innovation as a distinguished game development agency and one of
                the premier gaming companies in UK, pushing the boundaries by
                crafting immersive experiences that force players to come back
                for more! Explore the possibilities with TekRevol and let us
                take your gaming venture to new heights.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
